import React from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Button from "components/Button";

import SuccessCheck from "assets/images/success-check.svg";

import { routes } from "routes/routes";

import { useAppDispatch } from "store/hooks";
import { setIsEmailSent } from "store/features/authSlice";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

const EmailSend: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const noEmailReceived = () => {
    analytics().sendEvent(AnalyticsEvents.forgot_password_no_email_received);
    dispatch(setIsEmailSent(false));
  };

  const onGoBack = () => {
    analytics().sendEvent(AnalyticsEvents.forgot_password_go_back);
    navigate(routes.auth, { replace: true });
  };

  return (
    <Box textAlign={"center"}>
      <Box component="img" sx={{ mb: 3 }} alt="success" src={SuccessCheck} />
      <Typography sx={{ mb: 1 }} variant="h5">
        IBAN oplata
      </Typography>
      <Typography sx={{ mb: 3 }} variant="body1" color="grey700">
        Перевірте електронну пошту, там будуть інструкції для зміни пароля.
      </Typography>
      <Button
        sx={{ mb: 2 }}
        variant="contained"
        color="primary"
        fullWidth
        onClick={noEmailReceived}
      >
        Не отримали повідомлення?
      </Button>
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        withBorder
        onClick={onGoBack}
      >
        Повернутись
      </Button>
    </Box>
  );
};

export default EmailSend;
